export const dashboardSearchMap = [
  {
    keywords: ["product", "products", "items", "ingredient"],
    route: "/dashboard/products",
  },
  {
    keywords: ["add product", "new product"],
    route: "/dashboard/add-product",
  },
  {
    keywords: ["order", "orders", "purchase"],
    route: "/dashboard/orders",
  },
  {
    keywords: ["invoice", "billing"],
    route: "/dashboard/invoice",
  },
  {
    keywords: ["receipt", "receipts"],
    route: "/dashboard/receipt-manager",
  },
  {
    keywords: ["offer", "offers", "discount"],
    route: "/dashboard/offers",
  },
  {
    keywords: ["report", "reports", "sales"],
    route: "/dashboard/reports",
  },
  {
    keywords: ["issue", "issues", "problem"],
    route: "/dashboard/order-issues",
  },
  {
    keywords: ["help", "support"],
    route: "/dashboard/help",
  },
  {
    keywords: ["doc", "docs", "documentation"],
    route: "/dashboard/documentation",
  },
];
